import service from '@/store/services/workshop/pkb-service';

const state = {
  list: {},
  pkb: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, pkb) => {
    state.pkb = pkb;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};
 
const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((pkb) => { commit('SET_RESOURCE', pkb); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((pkb) => { commit('SET_RESOURCE', pkb); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((pkb) => { commit('SET_RESOURCE', pkb); });
  },

  update_status({commit, dispatch}, params) {
    return service.update_status(params)
      .then((pkb) => { commit('SET_RESOURCE', pkb); });
  },

  // partTable({commit, dispatch}, params) {
  //   return service.partTable(params)
  //     .then((pkb) => { commit('SET_RESOURCE', pkb); });
  // },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((pkb) => { commit('SET_RESOURCE', pkb); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  pkb: state => state.pkb,
  page: state => state.meta.page,
};
 
const pkb = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default pkb;
